/**
 * Route for `invoice-dispute-workflow`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { InvoiceDisputeWorkflowPage } from "../features/invoice-dispute-workflow/InvoiceDisputeWorkflowPage";

export const invoiceDisputeWorkflowRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/invoice-dispute-workflow",
	component: InvoiceDisputeWorkflowPage,
});

export default invoiceDisputeWorkflowRoute;
